
import React from "react";
import { Classname, Paginator, Scheme } from "@rivtn/noseur";
import styles from "../../assets/style.module.css";

export interface PaginationProps {
    page: number;
    rowsPerPage?: number;
    totalRecords?: number;
    onPageChange: (page: number) => void;
}

function Pagination({ page, rowsPerPage, totalRecords, onPageChange }: PaginationProps) {

    const pageButton = (icon?: string) => (option: any) => (
        <button className={Classname.build(styles["page-btn"], option.className, icon, { [styles["active"]]: !icon && option.active })} disabled={option.disabled} onClick={option.onClick}>
            {icon ? null : option.label}
        </button>
    );

    return (<Paginator scheme={Scheme.LIGHT} className={styles["pager"]} rowsPerPage={rowsPerPage} totalRecords={totalRecords} initialPage={page} onPageChange={(e) => onPageChange(e.currentPage)} template={{
        activePageLabel: () => "",
        pageElement: pageButton(),
        nextPageElement: pageButton("fa fa-angle-right"),
        previousPageElement: pageButton("fa fa-angle-left"),
        lastPageElement: pageButton("fa fa-angle-double-right"),
        firstPageElement: pageButton("fa fa-angle-double-left"),
    }} />);
}

export default Pagination;
